export { default, getStaticProps, getStaticPaths } from '../../src/pages/Series'
